import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { IRichBlockActions, RichBlockActionActivation } from '@pure1/data';
import { RichBlockActionButtonComponent } from '../rich-block-action-button/rich-block-action-button.component';
import { withSinglePrimary } from '../rich-block-emphasis';

/**
 * A row of buttons — the answer's recommendation made activatable (US2, R2.4).
 *
 * The renderer knows nothing about how an action is fulfilled: each button emits its intent and
 * this forwards it, which is what lets a standalone `actions` block, a `callout`'s actions and a
 * `task_list` step's action all terminate at one handler.
 */
@Component({
    selector: 'copilot-rich-block-actions',
    templateUrl: './actions-block.component.html',
    styleUrl: './actions-block.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    preserveWhitespaces: false,
    imports: [RichBlockActionButtonComponent],
})
export class ActionsBlockComponent {
    readonly block = input.required<IRichBlockActions>();

    readonly activateAction = output<RichBlockActionActivation>();

    /** R2.4: "at most one primary" is a rendering rule here, never a reason to drop the block. */
    protected readonly actions = computed(() => withSinglePrimary(this.block().actions));
}
